import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';

import { UtilsService } from 'src/app/shared/services/utils.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { LoginModel } from 'src/app/shared/classes/LoginModel';
import { categories } from 'src/app/shared/classes/categories.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'molla-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
	@Input() containerClass = "container";
	categories!:categories[];
	loginModel!:LoginModel;
  
		current = '/';
	
		private subscr: Subscription;

	constructor(
		private router: Router,
		public activeRoute: ActivatedRoute,
		public utilsService: UtilsService,
		public modalService: ModalService,
		private apiService: ApiService) {

					this.subscr = this.router.events.subscribe(event => {
						if (event instanceof NavigationStart) {
							this.current = event.url;
						} else if (event instanceof NavigationEnd) {
							this.current = event.url;
						}
					});
	}

	ngOnInit(): void {
		this.loginModel = JSON.parse(sessionStorage.getItem('currentUser')!);
		this.caricaCategorie()
	}

	showLoginModal(event: Event, backpage: string = 'shop/dashboard'): void {
		event.preventDefault();

		if (!this.loginModel) {
			this.modalService.showLoginModal(backpage);
		} else {
			this.router.navigate(['/shop/dashboard']);
		}
	}

	onCalcolatoreClick(event: Event): void {
		if (!this.loginModel) {
			// Apre il modal passando /shop/calcolatore come destinazione post-login
			this.showLoginModal(event, 'shop/calcolatore');
		} else {
			this.router.navigate(['/shop/calcolatore']);
		}
		}

	async caricaCategorie(){
		const fromDb = undefined;
		const params = fromDb || {};
		params.LIVELLO = 1;
		params.lingua = 'IT';

		this.categories = await this.apiService.fetchCategories(params);
	}
	
}
